/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li3_LabelInputs */

const tr_mesafeli_s5_li3_label = /** @type {(inputs: Mesafeli_S5_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Secure:`)
};

const en_mesafeli_s5_li3_label = /** @type {(inputs: Mesafeli_S5_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Secure:`)
};

const de_mesafeli_s5_li3_label = /** @type {(inputs: Mesafeli_S5_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Secure:`)
};

const ru_mesafeli_s5_li3_label = /** @type {(inputs: Mesafeli_S5_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Secure:`)
};

/**
* | output |
* | --- |
* | "3D Secure:" |
*
* @param {Mesafeli_S5_Li3_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li3_label = /** @type {((inputs?: Mesafeli_S5_Li3_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li3_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li3_label(inputs)
	if (locale === "de") return de_mesafeli_s5_li3_label(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li3_label(inputs)
	return tr_mesafeli_s5_li3_label(inputs)
});